import _ from 'lodash'
import type {DecorationSingleComponentPluginFunction} from '../../types'
import type {ComponentExportStructure} from '@wix/document-services-types'

export const unpack: DecorationSingleComponentPluginFunction = (component: ComponentExportStructure) => {
    if (!component.structure?.skin) {
        return
    }

    component.skin = component.structure.skin
    delete component.structure.skin

    if (_.isEmpty(component.structure)) {
        delete component.structure
    }
}
